import React from 'react';

const Rapport = () => (
    <>
        <h1>Déclaration d’accessibilité</h1>

        <p role="text">
            <strong>Le Ministère de l'Intérieur et des Outre-Mer</strong> s’engage à rendre ses
            sites internet, intranet, extranet et ses progiciels accessibles (et ses applications
            mobiles et mobilier urbain numérique) conformément à l’article 47 de la loi no 2005-102
            du 11 février 2005.
        </p>

        <p role="text">
            À cette fin, Le Ministère de l'Intérieur et des Outre-Mer met en œuvre la stratégie et
            les actions suivantes :
            <ul>
                <li>Aucun schéma pluriannuel de mise en accessibilité</li>
                <li>Aucun plan d’action de l’année en cours</li>
            </ul>
        </p>

        <p role="text">
            Cette déclaration d’accessibilité s’applique à{' '}
            <strong>SI Armes - Espace Détenteurs - contre audit - juin 2025</strong> (
            <a target="_blank" href="https://sia.detenteurs.interieur.gouv.fr/" rel="noreferrer">
                https://sia.detenteurs.interieur.gouv.fr/
            </a>
            )
        </p>

        <h2>État de conformité</h2>

        <p role="text">
            SI Armes - Espace Détenteurs - contre audit - juin 2025 est{' '}
            <strong>partiellement conforme</strong> avec le référentiel général d’amélioration de
            l’accessibilité (RGAA).
        </p>

        <h2>Résultats des tests</h2>

        <p role="text">
            L’audit de conformité réalisé par{' '}
            <strong>la Brigade d'Intervention du Numérique (BIN) de la DINUM</strong> révèle que{' '}
            <strong>70%</strong> des critères du RGAA version 4.1.2 sont respectés.
        </p>

        <h2>Contenus non accessibles</h2>

        <p role="text">
            Les contenus listés ci-dessous ne sont pas accessibles pour les raisons suivantes.
        </p>

        <h3>Non-conformités</h3>

        <div>
            <p role="text">Liste non exhaustive des erreurs détectées :</p>

            <ul>
                <li>Certaines images décoratives ne sont pas ignorées ;</li>
                <li>Le Captcha n'est pas accessible et n'a pas d'alternative accessible ;</li>
                <li>Les contrastes ne sont pas toujours respectés ;</li>
                <li>Les tableaux ne sont pas correctement structurés ;</li>
                <li>Les liens manquant parfois de pertinence ou n'ont pas d'intitulé ;</li>
                <li>Les messages de statut ne sont pas toujours restitué à l'usager ;</li>
                <li>La hiérarchie des titres est parfois problématique ;</li>
                <li>Des éléments de structure HTML sont parfois manquants ;</li>
                <li>Les listes ne sont pas toujours correctement structurées ;</li>
                <li>
                    Certaines fonctionnalités ne sont pas accessibles lorsque CSS est désactivé ;
                </li>
                <li>La prise de focus est parfois peu ou pas visible ;</li>
                <li>Certains champs de formulaire n'ont pas d'étiquette associée ;</li>
                <li>L'usager n'a pas toujours d'aide pour remplir les formulaires sans erreur ;</li>
                <li>L'usager n'a pas le contrôle sur la durée de sessio ;</li>
            </ul>
        </div>

        <h3>Dérogations pour charge disproportionnée</h3>

        <p role="text">Aucune</p>

        <h3>Contenus non soumis à l’obligation d’accessibilité</h3>

        <p role="text">Aucune</p>

        <h2> Établissement de cette déclaration d’accessibilité </h2>

        <p role="text">Cette déclaration a été établie le 18/06/2025.</p>

        <h3> Technologies utilisées pour la réalisation de l’audit </h3>

        <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>Javascript</li>
        </ul>

        <h3>Environnement de test</h3>

        <p role="text">
            Les vérifications de restitution de contenus ont été réalisées sur la base de la
            combinaison fournie par la base de référence du RGAA, avec les versions suivantes :
        </p>

        <ul>
            <li> Sur desktop MacOS avec Safari et VoiceOver </li>
            <li> Sur desktop Windows avec Firefox et JAWS </li>
            <li> Sur desktop Windows avec Firefox et NVDA </li>
            <li> Sur mobile iOS avec Safari et VoiceOver </li>
        </ul>

        <h3>Outils pour évaluer l’accessibilité</h3>

        <ul>
            <li>Web Developer Toolbar</li>
            <li>Colour Contrast Analyser</li>
            <li>HeadingsMap</li>
            <li>WCAG Contrast checker</li>
            <li>Inspecteur de composants</li>
            <li>Validateur HTML du W3C</li>
            <li>Contraste élevé</li>
        </ul>

        <h3> Pages du site ayant fait l’objet de la vérification de conformité </h3>

        <ul>
            <li>
                Authentification{' '}
                <strong>https://formation.sia.detenteurs.interieur.gouv.fr/auth</strong>
            </li>
            <li>
                Contact{' '}
                <strong>https://formation.sia.detenteurs.interieur.gouv.fr/nous-contacter</strong>
            </li>
            <li>
                Création de compte - Étape 1 sur 4{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/compte/creer/etape-1
                </strong>
            </li>
            <li>
                Création de compte - Étape 2 sur 4{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/compte/creer/etape-2
                </strong>
            </li>
            <li>
                Création de compte - Étape 3 sur 4{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/compte/creer/etape-3
                </strong>
            </li>
            <li>
                Création de compte - Étape 4 sur 4{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/compte/creer/etape-4
                </strong>
            </li>
            <li>
                Ratelier{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/espace-detenteurs/ratelier
                </strong>
            </li>
            <li>
                Gestion de mon compte{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/espace-detenteurs/mon-compte/gestion
                </strong>
            </li>
            <li>
                Mes démarches{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/espace-detenteurs/mes-demarches
                </strong>
            </li>
            <li>
                Mentions légales{' '}
                <strong>https://formation.sia.detenteurs.interieur.gouv.fr/mentions-legales</strong>
            </li>
            <li>
                Accessibilité{' '}
                <strong>https://formation.sia.detenteurs.interieur.gouv.fr/accessibilite</strong>
            </li>
            <li>
                Ajouter une arme{' '}
                <strong>
                    https://formation.sia.detenteurs.interieur.gouv.fr/espace-detenteurs/armes/signaler-arme-manquante
                </strong>
            </li>
        </ul>

        <h2>Retour d’information et contact</h2>

        <p role="text">
            Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le
            responsable de SI Armes - Espace Détenteurs pour être orienté vers une alternative
            accessible ou obtenir le contenu sous une autre forme.
        </p>

        <ul>
            <li>
                {' '}
                Envoyer un message :{' '}
                <a
                    target="_blank"
                    href="https://sia.detenteurs.interieur.gouv.fr/nous-contacter"
                    rel="noreferrer"
                >
                    https://sia.detenteurs.interieur.gouv.fr/nous-contacter
                </a>
            </li>
        </ul>

        <h2>Voies de recours</h2>

        <p role="text">
            Si vous constatez un défaut d’accessibilité vous empêchant d’accéder à un contenu ou une
            fonctionnalité du site, que vous nous le signalez et que vous ne parvenez pas à obtenir
            une réponse de notre part, vous êtes en droit de faire parvenir vos doléances ou une
            demande de saisine au Défenseur des droits.
        </p>

        <p role="text">Plusieurs moyens sont à votre disposition :</p>

        <ul>
            <li>
                <a
                    href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine"
                    target="_blank"
                    rel="noreferrer"
                >
                    {' '}
                    Écrire un message au Défenseur des droits <span>nouvelle fenêtre</span>
                </a>
            </li>
            <li>
                <a
                    href="https://www.defenseurdesdroits.fr/carte-des-delegues"
                    target="_blank"
                    rel="noreferrer"
                >
                    {' '}
                    Contacter le délégué du Défenseur des droits dans votre région{' '}
                    <span>nouvelle fenêtre</span>
                </a>
            </li>
            <li>
                {' '}
                Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) à :<br />
                <span>
                    Défenseur des droits
                    <br /> Libre réponse 71120
                    <br /> 75342 Paris CEDEX 07
                </span>
            </li>
        </ul>
    </>
);

export default Rapport;
